import { render, staticRenderFns } from "./Section4.vue?vue&type=template&id=1c24cabb&scoped=true"
import script from "./Section4.vue?vue&type=script&lang=js"
export * from "./Section4.vue?vue&type=script&lang=js"
import style0 from "./Section4.vue?vue&type=style&index=0&id=1c24cabb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c24cabb",
  null
  
)

export default component.exports